import { 
  setupPovertyPopups,
  clickPovertyPopups,
  counterUp,
  loadTheVideo,
  videoToggle,
  heroAnimation,
  whyExistAnimation,
  whereOperateAnimation,
  whatPovertyAnimation,
  ourImpactAnimation,
  yourImpactAnimation,
  persona1Animation,
  persona2Animation,
  persona3Animation,
  // africaMapAnimations,
} from './index';


window.addEventListener('load', function() {

  setupPovertyPopups();
  clickPovertyPopups();
  counterUp();
  loadTheVideo();
  videoToggle();
  heroAnimation();
  whyExistAnimation();
  whereOperateAnimation();
  whatPovertyAnimation();
  ourImpactAnimation();
  yourImpactAnimation();
  persona1Animation();
  persona2Animation();
  persona3Animation();
  // africaMapAnimations();

  
  $('.whatWeMakeSliderContainer').slick({
    infinite: true,
    slidesToShow: 1,
    asNavFor: ".lifestyleImageSlider",
    arrows:true,
    dots:true,
    prevArrow:'.sliderPrevNavArrow',
    nextArrow:'.sliderNextNavArrow',
    appendDots:'.sliderNavProgressBar',
    speed:500,
    cssEase: 'cubic-bezier(.17,.67,.28,1)',
    autoplay: true,
    autoplaySpeed: 4000,
  });

  $('.lifestyleImageSlider').slick({
    infinite: true,
    slidesToShow: 1,
    asNavFor: ".whatWeMakeSliderContainer",
    arrows:false,
    speed:500,
    cssEase: 'cubic-bezier(.17,.67,.28,1)',
    rtl: true,
  });

  $('.weMakeCategory[data-slide]').on('click', function(e) {
    e.preventDefault();
    var slideno = $(this).data('slide');
    $('.whatWeMakeSliderContainer').slick('slickGoTo', slideno - 1);
  });


   
   
  
  if ($(window).width() <= 767) {
      
  }
  else {
  
  }  
  
})

window.addEventListener('resize', function() {

  if ($(window).width() < 1024) {

  }
  else {

 }
});